import { render } from "./ColorPalette.vue?vue&type=template&id=0366d650&scoped=true"
import script from "./ColorPalette.vue?vue&type=script&lang=js"
export * from "./ColorPalette.vue?vue&type=script&lang=js"

import "./ColorPalette.vue?vue&type=style&index=0&id=0366d650&lang=scss&scoped=true"
import "./ColorPalette.vue?vue&type=style&index=1&id=0366d650&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0366d650"]])

export default __exports__